import React from 'react';
import { useIntl } from 'umi';
import RevenueGrowthComponent from '@intelligence/components/RevenueGrowth';
import { getComparableValue } from '../shared/valueUtils';
import { getValidRevenueGrowthFilterValue } from './utils';
import { FILTER_TYPE } from '../filterTypes';
import { OPT_TEXT_MAP, getPreviewTitle } from '../previewHelpers';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule } from '../controlModule';
import type { IRevenueGrowthFilterValue } from './types';

const RevenueGrowthRenderer: React.FC<IFilterRenderProps<IRevenueGrowthFilterValue>> = (props) => {
  const { field, label = '', buttonText, placeholderText, value, onChange, ...rest } = props;

  return (
    <RevenueGrowthComponent
      {...rest}
      key={field}
      buttonText={buttonText || label || 'dbi_revenue_growth'}
      placeholderText={placeholderText || 'dbi_input_growth'}
      value={getComparableValue(value)}
      onChange={(payload: any) => {
        onChange(payload);
      }}
    />
  );
};

const RevenueGrowthPreview: React.FC<{
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0];
  valueItem: any;
}> = (props) => {
  const { item, valueItem } = props;
  const { formatMessage } = useIntl();
  const previewValue = getValidRevenueGrowthFilterValue(valueItem);

  const content = previewValue
    ? `${OPT_TEXT_MAP[previewValue.opt] || previewValue.opt} ${previewValue.value}%`
    : formatMessage({ id: 'dbi_filterSave_none' });

  return (
    <>
      <span className="model-form-text">{getPreviewTitle(item, formatMessage)}</span>
      <span className="model-form-context">{content}</span>
    </>
  );
};

const getRenderPreview = (): NonNullable<IFilterTypeEntry['renderPreview']> => {
  // eslint-disable-next-line react/display-name
  return (item, value) => <RevenueGrowthPreview item={item} valueItem={value} />;
};

export const revenueGrowthControl: IFilterControlModule = {
  type: FILTER_TYPE.REVENUE_GROWTH,
  entry: {
    render: (props) => {
      return <RevenueGrowthRenderer {...props} />;
    },
  },
  getRenderPreview,
};
